<template>
    <section class="ContentBanner">
        <figure
            class="ContentBanner__image lazyload"
            :data-bgset="srcset"
        />
        <div class="ContentBanner__container container">
            <h2 class="ContentBanner__heading h2">
                {{ heading }}
            </h2>
            <BaseText
                :text="text"
                classes="container"
            />
        </div>
    </section>
</template>
<script>
export default {
    name: 'ContentBanner',
    props: {
        heading: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        },
        srcset: {
            type: String,
            default: null
        }
    }
}
</script>
<style lang="scss" scoped>

    .ContentBanner {
        position: relative;

        @include media-query(lap-and-up) {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding-bottom: getSpacing('xlarge');
            height: 700px;
        }

        .BaseText {
            text-align: center;
            padding-top: getSpacing('medium');
            padding-bottom: getSpacing('medium');

            @include media-query(lap-and-up) {
                color: getColor('white');
                text-align: left;
                padding: 0;
                padding-left: getSpacing('spacer');
                width: 50%;
            }
            @include media-query(lap) {
                padding-left: getSpacing('large')
            }
        }
    }

    .ContentBanner__container {
        @include media-query(lap-and-up) {
            position: relative;
            display: flex;
            align-items: flex-end;
        }
    }

    .ContentBanner__image {
        height: 380px;
        background-size: cover;
        background-color: $border-color;

        @include media-query(lap-and-up) {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            left: 0;
            align-items: flex-start;
        }
    }

    .ContentBanner__heading {
        position: absolute;
        color: getColor('white');
        font-size: 3.5rem;
        line-height: 0.8;
        text-align: center;
        left: 1.5rem;
        right: 1.5rem;
        margin-top: -80px;


        @include media-query(lap-and-up) {
            font-size: 7.1rem;
            position: static;
            text-align: left;
            padding-right: 0.5rem;
            margin-top: 0;
        }

        @include media-query(lap) {
            font-size: 5rem;
            width: 50%;
        }

        @include media-query(tiny) {
            font-size: 2.5rem;
        }

    }
</style>
